import dayjs from 'dayjs';
import StockService from '@/services/StockService';
import { filterMap } from '@/utils/helper';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: StockService.getAll,
    emptyMap: {}
  },
  stockItems: {},
  units: {},
  counts: {},
  deliveries: []
};

// getters
const localGetters = {
  getStockItemClone: (state, getters) => (stockItem, list = null) => {
    let stockItems = list;
    if (!list) {
      stockItems = getters.getCloneStockItemList;
    }
    return stockItems.find(s => s.cloneId == stockItem.masterId);
  },
  getCloneStockItemList: (state, getters) => {
    return getters.getArray('stockItems', false, false).filter(s => s.cloneId);
  }
};

export default {
  state: localState,
  getters: localGetters,
};